import React, { useContext } from "react";
// import pptpage from "../../../Dashboard/Charginganalysis/ChargingPPT.pdf";
import pptpage from "../../../Dashboard/Charginganalysis/ChargingFirstPage/ChargingPPT.pdf";
import DashboardMain from '../../DashboardMain/DashboardMain';
import AppContext from '../../../../store/AppContext';

function PPTPageCharginganalysis() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain>
        <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%" sandbox></iframe>
      </DashboardMain>
    </>
  );
}

export default PPTPageCharginganalysis;